import React from 'react';
import { EntityForm } from '../widgets/Forms';
import { SelectItem } from '../widgets/SelectItem';


export default function ProjectSearchForm(props) {

    return (
        <EntityForm ref={React.createRef()} viewId="GrantSetup" values={props.data}
            useCustomSettings={false} valueChangeHandler={props.valueChangeHandler}>
            {form =>
                <form className={form.classes.container} id="ProjectsSearchForm">
                    <td>
                        <SelectItem
                            dataUrl={"api/sims/GrantSetup/GetLookupList?listId=FinancialYear"}
                            id="FinancialYearID"
                            label="Financial Year"
                            className="w-150"
                            form={form}
                            InputProps={{
                                readOnly: props.disableFields
                            }}
                        />
                    </td>
                    <td>
                        <SelectItem
                            dataUrl={"api/sims/GrantSetup/GetLookupList?listId=ProjectType"}
                            id="ProjectTypeID"
                            label="Project Type"
                            className="w-150"
                            form={form}
                            InputProps={{
                                readOnly: props.disableFields
                            }}
                        />
                    </td>
                    <br>
                    </br>
                </form>
            }
        </EntityForm>
    );
}
